// import React, { useState } from 'react';
// import './Chat.css'; // Ensure you have the CSS file for styling

// const Chat = () => {
//     const [messages, setMessages] = useState([]);
//     const [inputValue, setInputValue] = useState('');
//     const [currentChat, setCurrentChat] = useState(''); // Track the current chat

//     const contacts = [
//         { id: 1, name: 'Bob', messages: [
//             { id: 1, sender: 'Bob', text: 'Hey Alice!', time: '10:00 AM' },
//             { id: 2, sender: 'Alice', text: 'Hi Bob!', time: '10:01 AM' },
//         ]},
//         { id: 2, name: 'Charlie', messages: [
//             { id: 1, sender: 'Charlie', text: 'What’s up? This is a longer message that will be truncated.', time: '10:05 AM' },
//             { id: 2, sender: 'Alice', text: 'Not much, you? This is a longer message that will be truncated.', time: '10:06 AM' },
//         ]},
//         // Add more contacts as needed
//     ];

//     const handleContactClick = (contact) => {
//         setMessages(contact.messages);
//         setCurrentChat(contact.name);
//     };

//     const handleSendMessage = () => {
//         if (inputValue.trim() && currentChat) {
//             const newMessage = {
//                 id: messages.length + 1,
//                 sender: 'Alice',
//                 text: inputValue,
//                 time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//             };
//             setMessages([...messages, newMessage]);
//             setInputValue('');
//         }
//     };

//     const handleBack = () => {
//         setMessages([]); // Clear messages
//         setCurrentChat(''); // Reset current chat
//     };

//     return (
//         <div className="app-container">
//             <div className="contacts-container">
//                 <div className="contacts-header">
//                     <button className="back-button" onClick={handleBack}>Back</button>
//                     <h2>Contacts</h2>
//                 </div>
//                 {contacts.map(contact => {
//                     const lastMessage = contact.messages[contact.messages.length - 1];
//                     return (
//                         <div 
//                             key={contact.id} 
//                             className="contact" 
//                             onClick={() => handleContactClick(contact)}
//                         >
//                             <div>{contact.name}</div>
//                             <div className="contact-info">
//                                 <div className="last-message">{lastMessage.text}</div>
//                                 <div>{lastMessage.time}</div>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//             <div className="chat-container">
//                 <div className="chat-header">
//                     <h2>Chat with {currentChat || 'Select a contact'}</h2>
//                 </div>
//                 <div className="chat-messages">
//                     {messages.map(message => (
//                         <div key={message.id} className={`message ${message.sender === 'Alice' ? 'sent' : 'received'}`}>
//                             <div className="message-text">{message.text}</div>
//                             <div className="message-time">{message.time}</div>
//                         </div>
//                     ))}
//                 </div>
//                 <div className="chat-input">
//                     <input
//                         type="text"
//                         placeholder="Type a message..."
//                         value={inputValue}
//                         onChange={(e) => setInputValue(e.target.value)}
//                         onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
//                     />
//                     <button onClick={handleSendMessage}>Send</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Chat;


// import React, { useState } from 'react';
// import './Chat.css'; // Ensure you have the CSS file for styling

// const Chat = () => {
//     const [messages, setMessages] = useState([]);
//     const [inputValue, setInputValue] = useState('');
//     const [currentChat, setCurrentChat] = useState(''); // Track the current chat
//     const [sidebarActive, setSidebarActive] = useState(false); // Track sidebar state

//     const contacts = [
//         { id: 1, name: 'Bob', messages: [
//             { id: 1, sender: 'Bob', text: 'Hey Alice!', time: '10:00 AM' },
//             { id: 2, sender: 'Alice', text: 'Hi Bob!', time: '10:01 AM' },
//         ]},
//         { id: 2, name: 'Charlie', messages: [
//             { id: 1, sender: 'Charlie', text: 'What’s up? This is a longer message that will be truncated.', time: '10:05 AM' },
//             { id: 2, sender: 'Alice', text: 'Not much, you?', time: '10:06 AM' },
//         ]},
//         // Add more contacts as needed
//     ];

//     const handleContactClick = (contact) => {
//         setMessages(contact.messages);
//         setCurrentChat(contact.name);
//         setSidebarActive(false); // Close sidebar when a contact is selected
//     };

//     const handleSendMessage = () => {
//         if (inputValue.trim() && currentChat) {
//             const newMessage = {
//                 id: messages.length + 1,
//                 sender: 'Alice',
//                 text: inputValue,
//                 time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//             };
//             setMessages([...messages, newMessage]);
//             setInputValue('');
//         }
//     };

//     const handleBack = () => {
//         setMessages([]); // Clear messages
//         setCurrentChat(''); // Reset current chat
//         setSidebarActive(false); // Close sidebar
//     };

//     const toggleSidebar = () => {
//         setSidebarActive(!sidebarActive); // Toggle sidebar state
//     };

//     return (
//         <div className={`app-container ${sidebarActive ? 'sidebar-active' : ''}`}>
//             <button className="toggle-button" onClick={toggleSidebar}>
//                 {sidebarActive ? 'Hide Contacts' : 'Show Contacts'}
//             </button>
//             <div className={`contacts-container ${sidebarActive ? 'active' : ''}`}>
//                 <div className="contacts-header">
//                     <button className="back-button" onClick={handleBack}>Back</button>
//                     <h2>Contacts</h2>
//                 </div>
//                 {contacts.map(contact => {
//                     const lastMessage = contact.messages[contact.messages.length - 1];
//                     return (
//                         <div 
//                             key={contact.id} 
//                             className="contact" 
//                             onClick={() => handleContactClick(contact)}
//                         >
//                             <div>{contact.name}</div>
//                             <div className="contact-info">
//                                 <div className="last-message">{lastMessage.text}</div>
//                                 <div>{lastMessage.time}</div>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//             <div className="chat-container">
//                 <div className="chat-header">
//                     <h2>Chat with {currentChat || 'Select a contact'}</h2>
//                 </div>
//                 <div className="chat-messages">
//                     {messages.map(message => (
//                         <div key={message.id} className={`message ${message.sender === 'Alice' ? 'sent' : 'received'}`}>
//                             <div className="message-text">{message.text}</div>
//                             <div className="message-time">{message.time}</div>
//                         </div>
//                     ))}
//                 </div>
//                 <div className="chat-input">
//                     <input
//                         type="text"
//                         placeholder="Type a message..."
//                         value={inputValue}
//                         onChange={(e) => setInputValue(e.target.value)}
//                         onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
//                     />
//                     <button onClick={handleSendMessage}>Send</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Chat;

import React, { useState } from 'react';
import './Chat.css'; // Ensure you have the CSS file for styling

const Chat = () => {
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [currentChat, setCurrentChat] = useState(''); // Track the current chat
    const [sidebarActive, setSidebarActive] = useState(false); // Track sidebar state

    const contacts = [
        { id: 1, name: 'Bob', messages: [
            { id: 1, sender: 'Bob', text: 'Hey Alice!', time: '10:00 AM' },
            { id: 2, sender: 'Alice', text: 'Hi Bob!', time: '10:01 AM' },
        ]},
        { id: 2, name: 'Charlie', messages: [
            { id: 1, sender: 'Charlie', text: 'What’s up? This is a longer message that will be truncated.', time: '10:05 AM' },
            { id: 2, sender: 'Alice', text: 'Not much, you?', time: '10:06 AM' },
        ]},
        // Add more contacts as needed
    ];

    const handleContactClick = (contact) => {
        setMessages(contact.messages);
        setCurrentChat(contact.name);
        setSidebarActive(false); // Close sidebar when a contact is selected
    };

    const handleSendMessage = () => {
        if (inputValue.trim() && currentChat) {
            const newMessage = {
                id: messages.length + 1,
                sender: 'Alice',
                text: inputValue,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            };
            setMessages([...messages, newMessage]);
            setInputValue('');
        }
    };

    const handleBack = () => {
        setMessages([]); // Clear messages
        setCurrentChat(''); // Reset current chat
        setSidebarActive(false); // Close sidebar
    };

    const toggleSidebar = () => {
        setSidebarActive(!sidebarActive); // Toggle sidebar state
    };

    return (
        <div className={`app-container ${sidebarActive ? 'sidebar-active' : ''}`}>
            <button className="toggle-button" onClick={toggleSidebar}>
                {sidebarActive ? 'Hide Contacts' : 'Show Contacts'}
            </button>
            <div className={`contacts-container ${sidebarActive ? 'active' : ''}`}>
                <div className="contacts-header">
                    <button className="back-button" onClick={handleBack}>Back</button>
                    <h2>Contacts</h2>
                </div>
                {contacts.map(contact => {
                    const lastMessage = contact.messages[contact.messages.length - 1];
                    return (
                        <div 
                            key={contact.id} 
                            className="contact" 
                            onClick={() => handleContactClick(contact)}
                        >
                            <div>{contact.name}</div>
                            <div className="contact-info">
                                <div className="last-message">{lastMessage.text}</div>
                                <div>{lastMessage.time}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={`chat-container ${sidebarActive ? '' : 'full-width'}`}>
                <div className="chat-header">
                    <h2>Chat with {currentChat || 'Select a contact'}</h2>
                </div>
                <div className="chat-messages">
                    {messages.map(message => (
                        <div key={message.id} className={`message ${message.sender === 'Alice' ? 'sent' : 'received'}`}>
                            <div className="message-text">{message.text}</div>
                            <div className="message-time">{message.time}</div>
                        </div>
                    ))}
                </div>
                <div className="chat-input">
                    <input
                        type="text"
                        placeholder="Type a message..."
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                    />
                    <button onClick={handleSendMessage}>Send</button>
                </div>
            </div>
        </div>
    );
};

export default Chat;

// import React, { useState } from 'react';
// import './Chat.css'; // Ensure you have the CSS file for styling

// const Chat = () => {
//     const [messages, setMessages] = useState([]);
//     const [inputValue, setInputValue] = useState('');
//     const [currentChat, setCurrentChat] = useState(''); // Track the current chat
//     const [sidebarActive, setSidebarActive] = useState(false); // Track sidebar state

//     const contacts = [
//         { id: 1, name: 'Bob', messages: [
//             { id: 1, sender: 'Bob', text: 'Hey Alice!', time: '10:00 AM', date: '2025-01-26' },
//             { id: 2, sender: 'Alice', text: 'Hi Bob!', time: '10:01 AM', date: '2025-01-26' },
//         ]},
//         { id: 2, name: 'Charlie', messages: [
//             { id: 1, sender: 'Charlie', text: 'What’s up? This is a longer message that will be truncated.', time: '10:05 AM', date: '2025-01-25' },
//             { id: 2, sender: 'Alice', text: 'Not much, you?', time: '10:06 AM', date: '2025-01-25' },
//             { id: 3, sender: 'Alice', text: 'Let’s meet tomorrow!', time: '10:07 AM', date: '2025-01-26' },
//         ]},
//         // Add more contacts as needed
//     ];

//     const handleContactClick = (contact) => {
//         setMessages(contact.messages);
//         setCurrentChat(contact.name);
//         setSidebarActive(false); // Close sidebar when a contact is selected
//     };

//     const handleSendMessage = () => {
//         if (inputValue.trim() && currentChat) {
//             const newMessage = {
//                 id: messages.length + 1,
//                 sender: 'Alice',
//                 text: inputValue,
//                 time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//                 date: new Date().toISOString().split('T')[0], // Get current date in YYYY-MM-DD format
//             };
//             setMessages([...messages, newMessage]);
//             setInputValue('');
//         }
//     };

//     const handleBack = () => {
//         setMessages([]); // Clear messages
//         setCurrentChat(''); // Reset current chat
//         setSidebarActive(false); // Close sidebar
//     };

//     const toggleSidebar = () => {
//         setSidebarActive(!sidebarActive); // Toggle sidebar state
//     };

//     // Function to get date heading
//     const getDateHeading = (date) => {
//         const today = new Date();
//         const messageDate = new Date(date);
        
//         if (messageDate.toDateString() === today.toDateString()) {
//             return 'Today';
//         } else if (messageDate.toDateString() === new Date(today.setDate(today.getDate() - 1)).toDateString()) {
//             return 'Yesterday';
//         } else {
//             return messageDate.toLocaleDateString(); // Return formatted date
//         }
//     };

//     // Function to render messages with date headings
//     const renderMessages = () => {
//         const groupedMessages = {};
        
//         // Group messages by date
//         messages.forEach(message => {
//             const date = message.date;
//             if (!groupedMessages[date]) {
//                 groupedMessages[date] = [];
//             }
//             groupedMessages[date].push(message);
//         });

//         return Object.keys(groupedMessages).map(date => (
//             <div key={date}>
//                 <div className="date-heading">{getDateHeading(date)}</div>
//                 {groupedMessages[date].map(message => (
//                     <div key={message.id} className={`message ${message.sender === 'Alice' ? 'sent' : 'received'}`}>
//                         <div className="message-text">{message.text}</div>
//                         <div className="message-time">{message.time}</div>
//                     </div>
//                 ))}
//             </div>
//         ));
//     };

//     return (
//         <div className={`app-container ${sidebarActive ? 'sidebar-active' : ''}`}>
//             <button className="toggle-button" onClick={toggleSidebar}>
//                 {sidebarActive ? 'Hide Contacts' : 'Show Contacts'}
//             </button>
//             <div className={`contacts-container ${sidebarActive ? 'active' : ''}`}>
//                 <div className="contacts-header">
//                     <button className="back-button" onClick={handleBack}>Back</button>
//                     <h2>Contacts</h2>
//                 </div>
//                 {contacts.map(contact => {
//                     const lastMessage = contact.messages[contact.messages.length - 1];
//                     return (
//                         <div 
//                             key={contact.id} 
//                             className="contact" 
//                             onClick={() => handleContactClick(contact)}
//                         >
//                             <div>{contact.name}</div>
//                             <div className="contact-info">
//                                 <div className="last-message">{lastMessage.text}</div>
//                                 <div>{lastMessage.time}</div>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//             <div className={`chat-container ${sidebarActive ? '' : 'full-width'}`}>
//                 <div className="chat-header">
//                     <h2>Chat with {currentChat || 'Select a contact'}</h2>
//                 </div>
//                 <div className="chat-messages">
//                     {renderMessages()}
//                 </div>
//                 <div className="chat-input">
//                     <input
//                         type="text"
//                         placeholder="Type a message..."
//                         value={inputValue}
//                         onChange={(e) => setInputValue(e.target.value)}
//                         onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
//                     />
//                     <button onClick={handleSendMessage}>Send</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Chat;
